<template>
	<div>
		<v-form ref="form" class="agency-budget">
			<egranty-section-divider
				icon="attach_money"
				:text="'Budżet (w ' + currencyCode + ')'"
			/>

			<v-layout row wrap>
				<v-flex d-flex xs2>
					<v-card color="grey lighten-1">
						<v-card-text style="padding: 8px; text-align: center">
							<strong style="font-size: 13px">Działania</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs2>
					<v-card color="grey lighten-1">
						<v-card-text style="padding: 8px; text-align: center">
							<strong style="font-size: 13px">Nazwa wydatku</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs2>
					<v-card color="grey lighten-1">
						<v-card-text style="padding: 8px; text-align: center">
							<strong style="font-size: 13px">Środki z MSZ</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs2>
					<v-card color="grey lighten-1">
						<v-card-text style="padding: 8px; text-align: center">
							<strong style="font-size: 13px">Paragraf</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs2>
					<v-card color="grey lighten-1">
						<v-card-text style="padding: 8px; text-align: center">
							<strong style="font-size: 13px">Środki z innych źródeł</strong>
						</v-card-text>
					</v-card>
				</v-flex>

				<v-flex d-flex xs2>
					<v-card color="grey lighten-1">
						<v-card-text style="padding: 8px; text-align: center">
							<strong style="font-size: 13px">Wszystkie źródła</strong>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>

			<v-layout v-for="(cost,index) in costs" :key="index">
				<v-flex d-flex xs2>
					<v-card class="agency-actions-costs-layout" color="grey lighten-5" style="width: 100%">
						<div class="ma-2" style="font-size: 12px">
							{{getCostActionName(cost)}}
						</div>
					</v-card>
				</v-flex>
				<v-flex d-flex xs2>
					<v-card color="grey lighten-5" style="width: 100%">
						<div class="ma-2" style="font-size: 12px">
							{{cost.expenseName}}
						</div>
					</v-card>
				</v-flex>
				<v-flex d-flex xs2>
					<v-card color="grey lighten-5">
						<div class="ma-2" style="text-align: right; font-size: 12px">
							{{getMszFundingsValue(cost)}}
						</div>
					</v-card>
				</v-flex>
				<v-flex d-flex xs2>
					<v-card color="grey lighten-5">
						<div class="ma-2" style="font-size: 12px">
							{{getCostParagraphName(cost)}}
						</div>
					</v-card>
				</v-flex>
				<v-flex d-flex xs2>
					<v-card color="grey lighten-5">
						<div class="ma-2" style="text-align: right; font-size: 12px">
							{{getOwnFundingsValue(cost)}}
						</div>
					</v-card>
				</v-flex>
				<v-flex d-flex xs2>
					<v-card color="grey lighten-5">
						<div class="ma-2" style="text-align: right; font-size: 12px">
							{{calculateTotalFundingForCost(cost)}}
						</div>
					</v-card>
				</v-flex>
			</v-layout>

			<div v-for="paragraph in paragraphs" :key="paragraph.arrayId">
				<v-layout v-if="paragraph.totalFundings">
					<v-flex d-flex xs2>
						<v-card color="grey lighten-1" style="margin: 0">
							<v-layout row>
								<v-card-text style="padding: 8px"><strong style="font-size: 12px">Suma
									({{paragraph.name}})</strong>
								</v-card-text>
							</v-layout>
						</v-card>
					</v-flex>
					<v-flex d-flex xs2>
						<v-card color="grey lighten-1">
							<v-card-text style="padding: 8px"/>
						</v-card>
					</v-flex>
					<v-flex d-flex xs2>
						<v-card color="grey lighten-1">
							<v-card-text style="text-align: right; padding: 8px">
								<strong style="font-size: 12px">{{formatMoney(paragraph.totalMszFundingsForParagraph) +
									(currencyCode === '' ? ' PLN' : (' ' + currencyCode))}}</strong>
							</v-card-text>
						</v-card>
					</v-flex>
					<v-flex d-flex xs2>
						<v-card color="grey lighten-1">
							<v-card-text style="padding: 8px"/>
						</v-card>
					</v-flex>
					<v-flex d-flex xs2>
						<v-card color="grey lighten-1">
							<v-card-text style="text-align: right; padding: 8px">
								<strong style="font-size: 12px">{{formatMoney(paragraph.totalOwnFundingsForParagraph) +
									(currencyCode === '' ? ' PLN' : (' ' + currencyCode))}}</strong>
							</v-card-text>
						</v-card>
					</v-flex>
					<v-flex d-flex xs2>
						<v-card color="grey lighten-1">
							<v-card-text style="text-align: right; padding: 8px">
								<strong style="font-size: 12px">{{formatMoney(paragraph.totalFundings) +
									(currencyCode === '' ? ' PLN' : (' ' + currencyCode))}}</strong>
							</v-card-text>
						</v-card>
					</v-flex>
				</v-layout>
			</div>
			<v-layout row wrap>
				<v-flex d-flex xs2>
					<v-card color="grey lighten-1">
						<v-card-text style="padding: 8px"><strong style="font-size: 12px">Suma (łącznie)</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs2>
					<v-card color="grey lighten-1">
						<v-card-text style="padding: 8px"/>
					</v-card>
				</v-flex>
				<v-flex d-flex xs2>
					<v-card color="grey lighten-1">
						<v-card-text style="text-align: right; padding: 8px"><strong style="font-size: 12px">{{formatMoney(totalMszFundings)
							+
							(currencyCode === '' ? ' PLN' : (' ' + currencyCode))}}</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs2>
					<v-card color="grey lighten-1">
						<v-card-text style="padding: 8px">
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs2>
					<v-card color="grey lighten-1">
						<v-card-text style="text-align: right; padding: 8px"><strong style="font-size: 12px">{{formatMoney(totalOwnFundings)
							+
							(currencyCode === '' ? ' PLN' : (' ' + currencyCode))}}</strong></v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs2>
					<v-card color="grey lighten-1">
						<v-card-text style="text-align: right; padding: 8px"><strong style="font-size: 12px">{{formatMoney(totalFundings)
							+
							(currencyCode === '' ? ' PLN' : (' ' + currencyCode))}}</strong></v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
		</v-form>
	</div>
</template>

<script>
	import {AgencyContestParagraph} from "@/api/generated/AgencyContestParagraph";
	import {Numbers} from "@/utils/Numbers";
	import EgrantySectionDivider from "../../../../genericComponents/EgrantySectionDivider";

	export default {
		name: "AgencyActionsCostsReadOnlyView",
		components: {
			EgrantySectionDivider
		},

		data () {
			return {
				costs: [],
				paragraphs: [],
			};
		},

		watch: {
			value: {
				immediate: true,
				handler (val) {
					if (val === undefined) return;
					this.costs = val;
					this.calculateTotalForParagraph();
				}
			}
		},

		props: {
			readonly: {default: false},
      currencyCode: {default: 'PLN'},
			value: {},
			actions: {},
			contestId: {}
		},

		mixins: [Numbers],

		computed: {

			totalOwnFundings () {
				return this.costs.reduce(function (cnt, o) {
					return isNaN(o.ownFundings) ? cnt : cnt + Number(o.ownFundings);
				}, 0);
			},

			totalMszFundings () {
				return this.costs.reduce(function (cnt, o) {
					return isNaN(o.mszFundings) ? cnt : cnt + Number(o.mszFundings);
				}, 0);
			},

			totalFundings () {
				return this.totalMszFundings + this.totalOwnFundings;
			}
		},

		methods: {
			getMszFundingsValue (cost) {
				return Numbers.methods.formatMoney(cost.mszFundings) + (this.currencyCode === '' ? ' PLN' : (' ' + this.currencyCode));
			},

			getOwnFundingsValue (cost) {
				return Numbers.methods.formatMoney(cost.ownFundings) + (this.currencyCode === '' ? ' PLN' : (' ' + this.currencyCode));
			},

			getCostActionName (cost) {
				let found = this.actions.find(a => a.id === cost.actionId);
				return found ? found.action : "";
			},

			getCostParagraphName (cost) {
				let found = this.paragraphs.find(p => p.id === cost.paragraphId);
				return found ? found.name : "";
			},

			calculateTotalFundingForCost (cost) {
				let ownFundings = cost.ownFundings === null ? 0 : parseFloat(cost.ownFundings);
				let mszFundings = cost.mszFundings === null ? 0 : parseFloat(cost.mszFundings);
				return Numbers.methods.formatMoney(ownFundings + mszFundings) + (this.currencyCode === '' ? ' PLN' : (' ' + this.currencyCode));
			},

			async validate () {
				return true;
			},

			loadParagraphs () {
				AgencyContestParagraph.getAllParagraphs(
					this,
					this.contestId,
					response => {
						this.paragraphs = response;
						this.paragraphs.sort(function (a, b) {
							const nameA = a.name.toUpperCase();
							const nameB = b.name.toUpperCase();
              return nameA > nameB ? 1 : -1;
						});
						this.paragraphs.forEach((paragraph) => {
							this.$set(paragraph, 'arrayId', 'par' + paragraph.id);
							this.$set(paragraph, 'totalMszFundingsForParagraph', 0);
							this.$set(paragraph, 'totalOwnFundingsForParagraph', 0);
						});
						this.calculateTotalForParagraph();
					}
				);
			},

			calculateTotalForParagraph () {
				this.paragraphs.forEach(
					paragraph => {
						paragraph.totalMszFundingsForParagraph =
							this.costs.reduce(function (cnt, o) {
								if (isNaN(o.mszFundings)) {
									return cnt;
								} else {
									return cnt + (o.paragraphId === paragraph.id ? Number(o.mszFundings) : 0);
								}
							}, 0);
						paragraph.totalOwnFundingsForParagraph =
							this.costs.reduce(function (cnt, o) {
								if (isNaN(o.ownFundings)) {
									return cnt;
								} else {
									return cnt + (o.paragraphId === paragraph.id ? Number(o.ownFundings) : 0);
								}
							}, 0);
						paragraph.totalFundings = paragraph.totalMszFundingsForParagraph + paragraph.totalOwnFundingsForParagraph;
					});
			}
		},

		mounted () {
			this.loadParagraphs();
		}
	};
</script>

<style scoped>
	.theme--dark .grey.lighten-5 {
		background-color: #1B1B1B !important;
	}

	.agency-action-costs-v-select-icon {
		display: flex;
		width: 100%;
	}
</style>
